import { InternalAxiosRequestConfig } from 'axios'
import { isPlainObject } from 'lodash'
import humps from 'humps'

export const decamelizeKeysInterceptor = (
  config: InternalAxiosRequestConfig
) => {
  if (isPlainObject(config.data)) {
    config.data = humps.decamelizeKeys(config.data)
  }

  if (isPlainObject(config.params)) {
    config.params = humps.decamelizeKeys(config.params)
  }

  return config
}
